import { render, staticRenderFns } from "./OrderCommentBadge.vue?vue&type=template&id=1f673ab0&scoped=true&"
import script from "./OrderCommentBadge.vue?vue&type=script&lang=js&"
export * from "./OrderCommentBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f673ab0",
  null
  
)

export default component.exports